
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my/settings/bank",
      function () {
        return require("private-next-pages/my/settings/bank/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my/settings/bank"])
      });
    }
  